module.exports = __webpack_public_path__ + "img/pr-12.c55748c1.png";